var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	3919: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [0,14,0,0], () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(46443))))))),
	5487: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))))),
	7063: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [,[-1,8,0,0],[0,6,6,0],2], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	8251: () => (loadSingletonVersion("default", "@elastic/apm-rum-angular-17", false, [1,5,17,2], () => (__webpack_require__.e(530).then(() => (() => (__webpack_require__(36530))))))),
	9647: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [,[-1,8,0,0],[0,6,6,0],2], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	9790: () => (loadSingletonVersion("default", "@angular/animations-angular-17", false, [,[1,18,0,0],[1,17,0,0],1], () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(47172))))))),
	10529: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [0,12,0,0], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	13334: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [1,7,8,1], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	14750: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [1,17,3,0], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	16261: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [0,10], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	19651: () => (loadSingleton("default", "@angular/forms-angular-17", false, () => (__webpack_require__.e(694).then(() => (() => (__webpack_require__(34456))))))),
	21116: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [1,17,3,2], () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(46443))))))),
	23657: () => (loadSingleton("default", "@angular/router-angular-17", false, () => (__webpack_require__.e(310).then(() => (() => (__webpack_require__(95072))))))),
	24378: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [1,17,3,0], () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))))),
	30060: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(80436))))))),
	33009: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [0,14,0,0], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	35322: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [1,17,3,2], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	35795: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [1,7,8,2], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	36024: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [4,17,3,12], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	37614: () => (loadSingleton("default", "rxjs-angular-17", false, () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	38209: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [1,7,0,0], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	40235: () => (loadSingletonVersion("default", "@angular/forms-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(456).then(() => (() => (__webpack_require__(34456))))))),
	42666: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [1,7,8,1], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	42779: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [,[1,7,4,0],[1,6,5,3],1], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	43090: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [1,17,3,0], () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(46443))))))),
	43772: () => (loadSingletonVersion("default", "@elastic/apm-rum-angular-17", false, [1,5,11,0], () => (__webpack_require__.e(530).then(() => (() => (__webpack_require__(36530))))))),
	47967: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [0,16,0,0], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	49356: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [1,17,3,2], () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))))),
	53150: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [4,17,3,12], () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(37580))))))),
	53217: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	54161: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(46443))))))),
	56131: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [0,14,0,0], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	60171: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [,[1,7,4,0],[1,6,5,3],1], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	62501: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [,[1,7,4,0],[1,6,5,5],1], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	65551: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	67584: () => (loadSingletonVersion("default", "@angular/forms-angular-17", false, [1,17,3,2], () => (__webpack_require__.e(456).then(() => (() => (__webpack_require__(34456))))))),
	67879: () => (loadSingletonVersion("default", "@angular/cdk-angular-17", false, [4,17,3,10], () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(31398))))))),
	71410: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [,[1,18,0,0],[1,17,0,0],1], () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(37580))))))),
	74075: () => (loadSingleton("default", "@angular/animations-angular-17", false, () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(47172))))))),
	76506: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(80436))))))),
	76571: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [1,7,8,2], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	79586: () => (loadSingleton("default", "rxjs/operators-angular-17", false, () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	79697: () => (loadSingletonVersion("default", "@angular/router-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(72).then(() => (() => (__webpack_require__(95072))))))),
	82163: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [0,12,0,0], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	83636: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [,[1,18,0,0],[1,17,0,0],1], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))))),
	85164: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [1,17,3,0], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))))),
	89999: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	92352: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [1,17,3,2], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	93699: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [0,10], () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(46443))))))),
	95129: () => (loadSingletonVersion("default", "@aw/cancel-reason-lib-angular-17", false, [2,4,3,0], () => (__webpack_require__.e(702).then(() => (() => (__webpack_require__(702))))))),
	95346: () => (loadSingleton("default", "@angular/platform-browser-angular-17", false, () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(80436))))))),
	99061: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [1,17,3,12], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	99633: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [,[1,7,4,0],[1,6,5,5],1], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))))),
	99659: () => (loadSingletonVersion("default", "rxjs/webSocket-angular-17", false, [1,7,8,2], () => (__webpack_require__.e(749).then(() => (() => (__webpack_require__(86749))))))),
	62733: () => (loadSingleton("default", "@angular/common-angular-17", false, () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(60316))))))),
	87363: () => (loadSingleton("default", "@angular/core/primitives/signals-angular-17", false, () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(85689))))))),
	96711: () => (loadSingleton("default", "@angular/core-angular-17", false, () => (__webpack_require__.e(199).then(() => (() => (__webpack_require__(37580))))))),
	75620: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [4,17,3,12], () => (__webpack_require__.e(681).then(() => (() => (__webpack_require__(46443))))))),
	25041: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-17", false, [4,17,3,12], () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(80436))))))),
	4255: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(62).then(() => (() => (__webpack_require__(46443))))))),
	16156: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [,[-1,8,0,0],[0,7,8,0],2], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	40229: () => (loadSingletonVersion("default", "@angular/forms-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(694).then(() => (() => (__webpack_require__(34456))))))),
	45381: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [,[-1,18,0,0],[0,17,0,0],2], () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))))),
	26707: () => (loadSingletonVersion("default", "tslib-angular-17", false, [1,2,1,0], () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(24398))))))),
	12917: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [1,17,0,0], () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))))),
	15028: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [,[1,7,5,0],[1,6,5,3],1], () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))))),
	16181: () => (loadSingletonVersion("default", "@angular/forms-angular-17", false, [0,14,0,0], () => (__webpack_require__.e(456).then(() => (() => (__webpack_require__(34456))))))),
	52175: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [1,17,0,0], () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(37580))))))),
	53116: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [,[1,7,5,0],[1,6,5,3],1], () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"45": [
		12917,
		15028,
		52175,
		53116
	],
	"55": [
		75620
	],
	"62": [
		53150,
		62733
	],
	"72": [
		25041
	],
	"74": [
		42779,
		60171,
		96711
	],
	"75": [
		36024,
		42779,
		53150,
		60171
	],
	"118": [
		3919,
		5487,
		7063,
		8251,
		9647,
		9790,
		10529,
		13334,
		14750,
		16261,
		19651,
		21116,
		23657,
		24378,
		30060,
		33009,
		35322,
		35795,
		36024,
		37614,
		38209,
		40235,
		42666,
		42779,
		43090,
		43772,
		47967,
		49356,
		53150,
		53217,
		54161,
		56131,
		60171,
		62501,
		65551,
		67584,
		67879,
		71410,
		74075,
		76506,
		76571,
		79586,
		79697,
		82163,
		83636,
		85164,
		89999,
		92352,
		93699,
		95129,
		95346,
		99061,
		99633,
		99659
	],
	"160": [
		71410
	],
	"172": [
		53150,
		62733
	],
	"199": [
		87363
	],
	"310": [
		25041,
		36024,
		53150
	],
	"316": [
		53150
	],
	"321": [
		4255,
		9790,
		14750,
		16156,
		19651,
		23657,
		24378,
		37614,
		40229,
		42779,
		45381,
		47967,
		53217,
		60171,
		62501,
		67879,
		71410,
		74075,
		79586,
		83636,
		85164,
		99633
	],
	"340": [
		26707
	],
	"371": [
		12917,
		15028,
		16181,
		52175,
		53116
	],
	"436": [
		36024,
		53150,
		75620
	],
	"443": [
		62733
	],
	"580": [
		42779,
		60171,
		87363
	],
	"620": [
		26707
	],
	"681": [
		42779,
		60171,
		62733
	],
	"691": [
		25041,
		36024,
		42779,
		53150,
		60171
	],
	"693": [
		96711
	],
	"694": [
		36024,
		53150
	],
	"702": [
		4255,
		16156,
		40229,
		45381
	],
	"818": [
		87363
	],
	"824": [
		42779,
		53150,
		60171,
		62733
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}